import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import packJson from '../../../../../package.json';
import Logo from 'assets/landing/likiee-logo.png';
import LanguageSelect from 'shared/components/layout/LanguageSelect';
import { getLocalizedPath } from 'utils/languageHelpers';
import './Footer.scss';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = moment().format('YYYY');

  return (
    <footer className='landing-footer'>
      <div className='landing-footer__container'>
        <div className='landing-footer__grid'>
          {/* Brand Column */}
          <div>
            <Link to={getLocalizedPath('/')} className='landing-footer__brand-link' aria-label='Likiee Home'>
              <img src={Logo} alt='Likiee' className='landing-footer__brand-logo' />
              <span className='landing-footer__brand-name'>Likiee</span>
            </Link>
            <p className='landing-footer__brand-description'>
              {t(
                'footer_description',
                'AI-powered visual search engine for fashion. Discover, compare, and shop smarter.',
              )}
            </p>
          </div>

          {/* Features Column */}
          <div>
            <h3 className='landing-footer__column-title'>{t('footer_features', 'Features')}</h3>
            <ul className='landing-footer__column-list'>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/look-builder')}>{t('nav_link_look_builder', 'Look Builder')}</Link>
              </li>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/virtual-try-on')}>{t('nav_link_virtual_tryon', 'Virtual Try-On')}</Link>
              </li>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/price-tracking')}>{t('nav_link_price_tracking', 'Price Tracking')}</Link>
              </li>
              {/* <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/ai-comparison')}>{t('nav_link_ai_compare', 'AI Comparison')}</Link>
              </li> */}
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/shared-wishlists')}>{t('nav_link_wishlists', 'Shared Wishlists')}</Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className='landing-footer__column-title'>{t('footer_company', 'Company')}</h3>
            <ul className='landing-footer__column-list'>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/contact')}>{t('nav_link_contact', 'Contact')}</Link>
              </li>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/imprint')}>{t('nav_link_imprint', 'Imprint')}</Link>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className='landing-footer__column-title'>{t('footer_legal', 'Legal')}</h3>
            <ul className='landing-footer__column-list'>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/policy')}>{t('nav_privacy', 'Privacy Policy')}</Link>
              </li>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/terms')}>{t('nav_terms', 'Terms of Service')}</Link>
              </li>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/cookie')}>{t('nav_cookies', 'Cookie Policy')}</Link>
              </li>
              <li className='landing-footer__column-item'>
                <Link to={getLocalizedPath('/faq')}>{t('nav_faq', 'FAQ')}</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className='landing-footer__bottom'>
          <div className='landing-footer__bottom-content'>
            <div className='landing-footer__bottom-left'>
              <p className='landing-footer__copyright'>{t('footer_copyright_text', { date: currentYear })}</p>
              <p className='landing-footer__tagline'>
                {t('footer_tagline', 'Made with ❤️ for fashion lovers worldwide')}
              </p>
            </div>
            <div className='landing-footer__bottom-right'>
              <div className='landing-footer__language-switcher'>
                <LanguageSelect />
              </div>
            </div>
          </div>
          <div className='text-center mt-4'>
            <p className='landing-footer__version'>{t('text_version', { version: packJson.version })}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
